<template>
  <div class="main-box">
    <div class="sonpage-container">
      <div class="son-main">
        <!-- 停用系统功能项 -->
        <el-row>
          <el-col :span="24">
            <div style="display: flex">
              <span class="font-title">{{ $t("messageAdd.deact.001") }}</span>
              <span class="tips-text3">{{ $t("messageAdd.deact.002") }}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <span class="secondfont-title">{{$t("messageAdd.deact.003")}}</span>
          </el-col>
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.004") }}</span>
            <el-input size="medium" v-model="deact.p" @input="handleInput"></el-input>
          </el-col>
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.005") }}</span>
            <el-select size="medium" v-model="deact.r">
              <el-option :label="$t('message.systemMsg.switchSelect.open')" :value="true"></el-option>
              <el-option :label="$t('message.systemMsg.switchSelect.close')" :value="false"></el-option>
            </el-select>
          </el-col>
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.006") }}</span>
            <el-date-picker size="medium" type="daterange" :range-separator="$t('messageAdd.deact.009')"
              :start-placeholder="$t('messageAdd.deact.007')" :end-placeholder="$t('messageAdd.deact.008')"
              v-model="timesValue" @change="handleDateChange" value-format="yyyy-MM-dd" :clearable="false">
            </el-date-picker>
          </el-col>
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.010") }}</span>
            <el-select size="medium" v-model="deact.rfr">
              <el-option :label="$t('message.systemMsg.switchSelect.open')" :value="true"></el-option>
              <el-option :label="$t('message.systemMsg.switchSelect.close')" :value="false"></el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="setting-box"> </el-col>
          <el-col :span="8" class="setting-box">
            <span class="deactText">{{ $t("messageAdd.deact.046") }}</span>
          </el-col>
        </el-row>
        <!-- 系统功能项 -->
        <el-row>
          <el-col :span="24">
            <span class="secondfont-title">{{$t("messageAdd.deact.011")}}</span>
          </el-col>
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.012") }}</span>
            <el-select size="medium" v-model="deact.wf2">
              <!-- <el-option :label="$t('messageAdd.deact.031')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.032')" :value="1"></el-option> -->
              <el-option :label="$t('messageAdd.deact.047')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.048')" :value="1"></el-option>
              <el-option :label="$t('messageAdd.deact.049')" :value="2"></el-option>
              <el-option :label="$t('messageAdd.deact.050')" :value="3"></el-option>
            </el-select>
          </el-col>
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.013") }}</span>
            <el-select size="medium" v-model="deact.sf">
              <el-option :label="$t('messageAdd.deact.031')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.032')" :value="1"></el-option>
            </el-select>
          </el-col>
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.014") }}</span>
            <el-select size="medium" v-model="deact.pf">
              <el-option :label="$t('messageAdd.deact.031')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.032')" :value="1"></el-option>
            </el-select>
          </el-col>
          <!-- <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t('messageAdd.deact.015') }}</span>
            <el-select size="medium" v-model="deact.af">
              <el-option :label="$t('messageAdd.deact.031')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.032')" :value="1"></el-option>
            </el-select>
          </el-col> -->
          <!-- 飞行模式设置 -->
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.016") }}</span>
            <el-select size="medium" v-model="deact.ff">
              <!-- <el-option :label="$t('messageAdd.deact.038')" :value="1"></el-option>
              <el-option :label="$t('messageAdd.deact.039')" :value="0"></el-option> -->
              <el-option :label="$t('messageAdd.deact.047')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.048')" :value="1"></el-option>
              <el-option :label="$t('messageAdd.deact.049')" :value="2"></el-option>
              <el-option :label="$t('messageAdd.deact.050')" :value="3"></el-option>
            </el-select>
          </el-col>
          <!-- <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t('messageAdd.deact.017') }}</span>
            <el-select size="medium" v-model="deact.df">
              <el-option :label="$t('messageAdd.deact.031')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.032')" :value="1"></el-option>
            </el-select>
          </el-col> -->
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.018") }}</span>
            <el-select size="medium" v-model="deact.bf2">
              <!-- <el-option :label="$t('messageAdd.deact.031')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.032')" :value="1"></el-option> -->
              <el-option :label="$t('messageAdd.deact.047')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.048')" :value="1"></el-option>
              <el-option :label="$t('messageAdd.deact.049')" :value="2"></el-option>
              <el-option :label="$t('messageAdd.deact.050')" :value="3"></el-option>
            </el-select>
          </el-col>
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.019") }}</span>
            <el-select size="medium" v-model="deact.gf2">
              <!-- <el-option :label="$t('messageAdd.deact.031')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.032')" :value="1"></el-option> -->
              <el-option :label="$t('messageAdd.deact.047')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.048')" :value="1"></el-option>
              <el-option :label="$t('messageAdd.deact.049')" :value="2"></el-option>
              <el-option :label="$t('messageAdd.deact.050')" :value="3"></el-option>
            </el-select>
          </el-col>
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.020") }}</span>
            <el-select size="medium" v-model="deact.cf">
              <el-option :label="$t('messageAdd.deact.031')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.032')" :value="1"></el-option>
            </el-select>
          </el-col>
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.021") }}</span>
            <el-select size="medium" v-model="deact.nf2">
              <!-- <el-option :label="$t('messageAdd.deact.031')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.032')" :value="1"></el-option> -->
              <el-option :label="$t('messageAdd.deact.047')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.048')" :value="1"></el-option>
              <el-option :label="$t('messageAdd.deact.049')" :value="2"></el-option>
              <el-option :label="$t('messageAdd.deact.050')" :value="3"></el-option>
            </el-select>
          </el-col>
          <!-- <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t('messageAdd.deact.022') }}</span>
            <el-select size="medium" v-model="deact.ef">
              <el-option :label="$t('messageAdd.deact.031')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.032')" :value="1"></el-option>
            </el-select>
          </el-col> -->
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.023") }}</span>
            <el-select size="medium" v-model="deact.rf">
              <el-option :label="$t('messageAdd.deact.031')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.032')" :value="1"></el-option>
            </el-select>
          </el-col>
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.025") }}</span>
            <el-select size="medium" v-model="deact.tf">
              <el-option :label="$t('messageAdd.deact.031')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.032')" :value="1"></el-option>
            </el-select>
          </el-col>
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.041") }}</span>
            <el-select size="medium" v-model="deact.us">
              <el-option :label="$t('messageAdd.deact.031')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.032')" :value="1"></el-option>
            </el-select>
          </el-col>
          <el-col :span="10" class="setting-box">
            <span class="setTitle">{{ $t("messageAdd.deact.051") }}</span>
            <el-select size="medium" v-model="deact.wh">
              <el-option :label="$t('messageAdd.deact.031')" :value="0"></el-option>
              <el-option :label="$t('messageAdd.deact.032')" :value="1"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
      <!-- 页脚 -->
      <div class="footer-btns">
        <footer-btn
          @childEvent="handleChildEvent"
          @fatherPagePreviewQRCode="fatherPagePreviewQRCode"
          @handleDownLoadQrCodeFile="handleDownLoadQrCodeFile"
          @handleDownLoadQRCodeImg="handleDownLoadQRCodeImg"
          @handlePreviewQrCodeFile="handlePreviewQrCodeFile"
          @handleSavePlan="handleSavePlan"
        ></footer-btn>
      </div>
    </div>
    <!-- 二维码展示子组件 -->
    <qrcode-page :showDialog.sync="isQRCodeVisible" :qrCodeTxt="qrCodeTxt" :qrCodeTitle="qrCodeTitle"></qrcode-page>
    <!-- 保存为方案组件 -->
    <save-plan
      :showPlanDialog.sync="planDialogVisible"
      :savePlanId="savePlanId"
      :saveName="saveName"
      :planType="planType"
      :fatherPlanData="fatherPlanData"
      :fatherPlanNoHandleData="fatherPlanNoHandleData"
      @handleClosePlanDialog="handleClosePlanDialog"
    ></save-plan>
  </div>
</template>
<script>
import footerBtn from "@/components/footerBtns.vue";
import qrcodePage from "@/components/showQRCode.vue";
import savePlan from "@/components/saveAsPlan.vue";
import { downFileData, txtToQRtxt } from "@/utils/qrCodeFunctions.js";
import QRCode from 'qrcode';
import JSZip from "jszip";
import FileSaver from "file-saver";
import { cloneDeep } from "lodash";
import { removeEmptyProperty } from "@/utils/index.js";
export default {
  data() {
    return {
      deact: {
        p: "4007770876",
        r: null,
        t: '',
        rfr: null,
        wf: null,
        sf: null,
        pf: null,
        // af: null,
        ff: null,
        // df: null,
        bf: null,
        gf: null,
        cf: null,
        nf: null,
        // ef: null,
        rf: null,
        tf: null,
        us: null,
        wf2: null,
        bf2: null,
        gf2: null,
        nf2: null,
        wh: null,
      },
      timesValue: [], //时间
      // 二维码展示
      isQRCodeVisible: false,
      planDialogVisible: false,
      planType: 4,
      fatherPlanData: {},
      qrCodeTxt: "",
      qrCodeTitle: "",
      fatherPlanNoHandleData: {},
      // 路由传来的保存方案数据
      savePlanId: "",
      saveName: "",
    };
  },
  components: {
    footerBtn,
    qrcodePage,
    savePlan,
  },
  watch: {
    deact: {
      handler(newVal) {
        this.saveDeact(newVal);
      },
      deep: true,
    },
  },
  methods: {
    // 判断密码是否填写
    handlePwd() {
      if (this.deact.p) {
        return true;
      } else {
        return false;
      }
    },
    // 校验密码输入框
    handleInput(value) {
      const r = /^[a-zA-Z0-9\\W_!@#$%^&*`~()-+=]{0,15}$/;
      if (!r.test(value)) {
        this.$message.error(this.$t("messageAdd.deact.040"));
        this.deact.p = "";
      }
    },
    // 处理时间分割事件
    handleDateChange(value) {
      // 当日期范围变化时触发
      if (value && value.length === 2) {
        // 使用 &#126; 连接开始日期和结束日期
        this.deact.t = `${value[0]}~${value[1]}`;
      } else {
        // 如果日期范围为空，则清空 deact.t
        this.deact.t = "";
      }
      // 保存到本地存储
      this.saveDeact(this.deact);
    },
    // 保存到本地存储
    saveDeact(newVal) {
      let deact_new = removeEmptyProperty(newVal); // 移除空属性
      localStorage.setItem("deact", JSON.stringify(deact_new));
    },
    // 处理保存方案
    handleSavePlan() {
      let res = this.handlePwd();
      if (res) {
        // 调用接口传方案至后端
        this.planDialogVisible = true;
        const parsedData = JSON.parse(localStorage.getItem("deact"));
        const parsedData_sync = this.syncData(parsedData);
        const cleanedData = this.cleanEmptyStrArrObj(parsedData_sync);
        this.fatherPlanData = cloneDeep(cleanedData);
        this.fatherPlanNoHandleData = cloneDeep(parsedData_sync);
      } else {
        this.$message.error(this.$t("messageAdd.deact.030"));
      }
    },
    // 处理空数据(数组，对象，字符串)一级
    cleanEmptyStrArrObj(data) {
      const result = {};
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          const value = data[key];
          if (Array.isArray(value) && value.length === 0) {
            // 如果是空数组，则不添加到结果对象中
          } else if (typeof value === 'object' && value !== null && Object.keys(value).length === 0) {
            // 如果是空对象，则不添加到结果对象中
          } else if (typeof value === 'string' && value === "") {
            // 如果是空字符串，则不添加到结果对象中
          } else {
            // 否则，添加到结果对象中
            result[key] = value;
          }
        }
      }
      return result;
    },
    // 关闭处理保存方案弹框
    handleClosePlanDialog(val) {
      this.planDialogVisible = val;
    },
    // 重置本页
    handleChildEvent() {
      try {
        const deactItem = JSON.parse(localStorage.getItem("deact"));
        // 检查deactItem是否为非空对象
        if (deactItem && Object.keys(deactItem).length > 0) {
          // 如果'deact'存在且不为空对象，则移除它
          localStorage.removeItem("deact");
          // 重置组件内的属性
          this.deact = { p: "4007770876" };
          this.timesValue = [];
          this.$message.success(this.$t("messageAdd.deact.027"));
        } else {
          this.$message.closeAll();
          this.$message.error(this.$t("messageAdd.deact.028"));
        }
      } catch (error) {
        this.$message.closeAll();
        this.$message.error(this.$t("messageAdd.deact.029"));
      }
    },
    // 预览二维码
    fatherPagePreviewQRCode() {
      let res = this.handlePwd();
      if (res) {
        const deactItem = JSON.parse(localStorage.getItem("deact"));
        if (deactItem && Object.keys(deactItem).length > 0) {
          const deactItem_new = this.syncData(deactItem);
          // 将对象转为字符串，因为二维码内容不能直接展示对象
          const deactSSF = {
            ssf: {
              ...deactItem_new,
            },
          };
          const deactItemStr = JSON.stringify(deactSSF);
          this.qrCodeTxt = deactItemStr;
          this.qrCodeTitle = this.$t("messageAdd.deact.026");
          this.isQRCodeVisible = true; // 显示二维码
        } else {
          this.$message.closeAll();
          this.$message.error(this.$t("messageAdd.deact.028"));
        }
      } else {
        this.$message.error(this.$t("messageAdd.deact.030"));
      }
    },
    // 导出配置文件
    handleDownLoadQrCodeFile() {
      let res = this.handlePwd();
      if (res) {
        const deactItem = JSON.parse(localStorage.getItem("deact"));
        if (deactItem && Object.keys(deactItem).length > 0) {
          const deactItem_new = this.syncData(deactItem);
          const deactSSF = {
            ssf: {
              ...deactItem_new,
            },
          };
          downFileData("Config_stn2.json", JSON.stringify(deactSSF));
        } else {
          this.$message.closeAll();
          this.$message.error(this.$t("messageAdd.deact.028"));
        }
      } else {
        this.$message.error(this.$t("messageAdd.deact.030"));
      }
    },
    // 导出二维码
    async handleDownLoadQRCodeImg() {
      this.qrCodeTitle = this.$t("messageAdd.deact.026");
      const deactItem = JSON.parse(localStorage.getItem("deact"));
      if (deactItem && Object.keys(deactItem).length > 0) {
        const deactItem_new = this.syncData(deactItem);
        const deactSSF = { ssf: { ...deactItem_new } };
        const deactItemStr = JSON.stringify(deactSSF);
        const qrCodeArr = txtToQRtxt(deactItemStr, "<stn2>");
        if (qrCodeArr.length > 0) {
          const date = new Date();
          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          const day = date.getDate();
          const dayStr = year + "" + "0" + month + "" + day;
          const zip = new JSZip();
          const img = zip.folder(`config_${dayStr}`);
          const myNoteName = "offlineConfigZip";
          for (let i = 0; i < qrCodeArr.length; i++) {
            const url = await QRCode.toDataURL(qrCodeArr[i], {
              width: 200,
              margin: 1,
            });
            const image = url.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
            const imagesName = `${this.qrCodeTitle} ${i + 1}.png`;
            img?.file(imagesName, image, { base64: true });
          }
          const content = await zip.generateAsync({ type: "blob" });
          FileSaver.saveAs(content, `${myNoteName}.zip`);
        } else {
          console.log('没有配置');
        }
      } else {
        this.$message.closeAll();
        this.$message.error(this.$t("messageAdd.deact.028"));
      }
    },
    // 初始化参数
    initData() {
      const deactItem = JSON.parse(localStorage.getItem("deact"));
      if (deactItem) {
        Object.assign(this.deact, deactItem);

        // 兼容旧版本APP-wifi
        if ((this.deact?.wf !== undefined && this.deact?.wf !== null) && (this.deact?.wf2 === undefined || this.deact?.wf2 === null)) {
          this.deact.wf2 = this.deact.wf === 1 ? 2 : 3;
        }

        // 兼容旧版本APP-蓝牙
        if ((this.deact?.bf !== undefined && this.deact?.bf !== null) && (this.deact?.bf2 === undefined || this.deact?.bf2 === null)) {
          this.deact.bf2 = this.deact.bf === 1 ? 2 : 3;
        }

        // 兼容旧版本APP-gps
        if ((this.deact?.gf !== undefined && this.deact?.gf !== null) && (this.deact?.gf2 === undefined || this.deact?.gf2 === null)) {
          this.deact.gf2 = this.deact.gf === 1 ? 2 : 3;
        }

        // 兼容旧版本APP-nfc
        if ((this.deact?.nf !== undefined && this.deact?.nf !== null) && (this.deact?.nf2 === undefined || this.deact?.nf2 === null)) {
          this.deact.nf2 = this.deact.nf === 1 ? 2 : 3;
        }

        // 当返回值里有时间
        if (this.deact.t && this.deact.t != "") {
          this.timesValue = this.deact.t.split("~");
        }
      }
    },
    // 同步到老字段 兼容APP操作
    syncData(deactItem) {
      // 新字段同步到旧字段兼容老版本APP使用
      // wifi
      if (deactItem?.wf2 !== undefined && deactItem?.wf2 !== null) {
        if (deactItem.wf2 === 0 || deactItem.wf2 === 2) {
          deactItem.wf = 1;
        } else if (deactItem.wf2 === 1 || deactItem.wf2 === 3) {
          deactItem.wf = 0;
        }
      }
      // 蓝牙
      if (deactItem?.bf2 !== undefined && deactItem?.bf2 !== null) {
        if (deactItem.bf2 === 0 || deactItem.bf2 === 2) {
          deactItem.bf = 1;
        } else if (deactItem.bf2 === 1 || deactItem.bf2 === 3) {
          deactItem.bf = 0;
        }
      }

      // gps
      if (deactItem?.gf2 !== undefined && deactItem?.gf2 !== null) {
        if (deactItem.gf2 === 0 || deactItem.gf2 === 2) {
          deactItem.gf = 1;
        } else if (deactItem.gf2 === 1 || deactItem.gf2 === 3) {
          deactItem.gf = 0;
        }
      }

      // nfc
      if (deactItem?.nf2 !== undefined && deactItem?.nf2 !== null) {
        if (deactItem.nf2 === 0 || deactItem.nf2 === 2) {
          deactItem.nf = 1;
        } else if (deactItem.nf2 === 1 || deactItem.nf2 === 3) {
          deactItem.nf = 0;
        }
      }
      return deactItem;
    },
    // 预览文件
    handlePreviewQrCodeFile() {
      const parsedData = JSON.parse(localStorage.getItem("deact"));
      console.log('parsedData', parsedData);
    }
  },
  created() {
    this.initData();
    // 获取路由参数id,name
    this.savePlanId = this.$route.params.id;
    this.saveName = this.$route.params.name;
  },
};
</script>
